import { createApp } from 'vue';
import App from '../views/pages/user/chat/App.vue';
import store from './store'; // Import the Vuex store

// Initialize Vue application with Vuex store and mount it
createApp(App)
  .use(store) // Use the Vuex store
  .mount('#app');
